import { AgeRestrictionMessageUI } from "./AgeRestrictionMessageUI";
import { StandardProps } from "@/components/componentMap";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "@/utils/product/ensureIsActive";
import { useVariant } from "@/hooks/useVariant/useVariant";

export const AgeRestrictionMessage = ({
  product,
}: Pick<StandardProps, "product" | "configProps" | "runtimeConfig">) => {
  const activeProduct = ensureIsActive(product);
  const { variant } = useVariant(product);
  const activeVariant = ensureIsActiveVariant(variant);

  if (!activeVariant || !activeProduct) return null;

  if (!activeVariant.availability.availableToOrder) return null;

  return (
    <AgeRestrictionMessageUI
      bladedArticle={activeVariant.sellingRestrictions?.age?.bladedArticle}
      minimumAge={activeVariant.sellingRestrictions?.age?.minimumAge ?? 0}
    />
  );
};
